<template>
    <span :class="addedClasses">{{ time }}</span>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        name: "Clock",
        props: {
            timezone: {
                required: true
            },
            addedClasses: {
                required: false
            }
        },
        data() {
            return {
                time: dayjs.createFromTimezone(null, this.timezone).format('HH:mm')
            }
        },
        mounted() {
            setInterval(this.getTime, 1000);
        },
        methods: {
            getTime() {
                this.time = dayjs.createFromTimezone(null, this.timezone).format('HH:mm')
            }
        }
    }
</script>
